import { NgModule } from "@angular/core";
import { Routes, RouterModule, ExtraOptions } from "@angular/router";
import { accountsModuleLazyLoadRoutes } from "./accounts/accounts.routes";
import { authModuleLazyLoadRoutes } from "./auth/auth.routes";
import { broadcastsModuleLazyLoadRoutes } from "./broadcasts/broadcasts.routes";
import { dashboardModuleLazyLoadRoutes } from "./dashboard/dashboard.routes";
import { facilitiesModuleLazyLoadRoutes } from "./facilities/facilities.routes";
import { playgroundModuleLazyLoadRoutes } from "./playground/playground.routes";
import { rolesModuleLazyLoadRoutes } from "./roles/roles.routes";
import { usersModuleLazyLoadRoutes } from "./user/users.routes";
import { geofencesModuleLazyLoadRoutes } from "./geofences/geofences.routes";
import { instrumentationModuleLazyLoadRoutes } from "./instrumentation/instrumentation.routes";
import { customersModuleLazyLoadRoutes } from "./customers/customers.routes";
import { contentModuleLazyLoadRoutes } from "./content/content.routes";
import { beaconsModuleLazyLoadRoutes } from "./beacons/beacons.routes";
import { beaconRegionsModuleLazyLoadRoutes } from "./beacon-regions/beacon-regions.routes";
import { appsModuleLazyLoadRoutes } from "./apps/apps.routes";
import { intelligenceModuleLazyLoadRoutes } from "./intelligence/intelligence.routes";
import { flowsModuleLazyLoadRoutes } from "./flows/flows.routes";
import { flowTestsModuleLazyLoadRoutes } from "./flow-tests/flow-tests-routing.module";
import { ErrorComponent } from "./error/error.component";
import { FromAuthGuard } from "./auth/auth.guards";
import { NotFoundComponent } from "./not-found/not-found.component";
import { statsModuleLazyLoadRoutes } from "./stats/stats.routes";
import { integrationsModuleLazyLoadRoutes } from "./integrations/integrations.routes";
import { emailCompletionModuleLazyLoadRoutes } from "./email-completion/email-completion-routing.module";
import { lumaModuleLazyLoadRoutes } from "./luma/luma-routing.module";
import { assististModuleLazyLoadRoutes } from "./assistist/assistist.routes";
import { docsModuleLazyLoadRoutes } from "./docs/docs-routing.module";

const routes: Routes = [
  ...authModuleLazyLoadRoutes,
  ...docsModuleLazyLoadRoutes,
  ...dashboardModuleLazyLoadRoutes,
  ...facilitiesModuleLazyLoadRoutes,
  ...playgroundModuleLazyLoadRoutes,
  ...usersModuleLazyLoadRoutes,
  ...accountsModuleLazyLoadRoutes,
  ...rolesModuleLazyLoadRoutes,
  ...broadcastsModuleLazyLoadRoutes,
  ...geofencesModuleLazyLoadRoutes,
  ...instrumentationModuleLazyLoadRoutes,
  ...customersModuleLazyLoadRoutes,
  ...contentModuleLazyLoadRoutes,
  ...beaconsModuleLazyLoadRoutes,
  ...beaconRegionsModuleLazyLoadRoutes,
  ...appsModuleLazyLoadRoutes,
  ...intelligenceModuleLazyLoadRoutes,
  ...flowsModuleLazyLoadRoutes,
  ...flowTestsModuleLazyLoadRoutes,
  ...statsModuleLazyLoadRoutes,
  ...integrationsModuleLazyLoadRoutes,
  ...emailCompletionModuleLazyLoadRoutes,
  ...lumaModuleLazyLoadRoutes,
  ...assististModuleLazyLoadRoutes,
  { path: "", redirectTo: "/dashboard", pathMatch: "full" },
  {
    path: "error",
    component: ErrorComponent,
    data: { title: "5xx Error" },
    canActivate: [FromAuthGuard],
  },
  { path: "notFound", component: NotFoundComponent },
  { path: "**", redirectTo: "/notFound" },
];

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: "always",
  onSameUrlNavigation: 'reload'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
